import { render, staticRenderFns } from "./VinovaTemplate.vue?vue&type=template&id=3c89f831&scoped=true&"
import script from "./VinovaTemplate.vue?vue&type=script&lang=js&"
export * from "./VinovaTemplate.vue?vue&type=script&lang=js&"
import style0 from "./VinovaTemplate.vue?vue&type=style&index=0&id=3c89f831&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c89f831",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBadge,VBtn,VIcon,VSpacer,VToolbarTitle})
